
/* injects from baggage-loader */

'use strict';

export default class ProjectManagerAnalyticsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
